import React from "react";
import { Star } from "lucide-react";

const StarFavorite = ({ isFavorite, onToggle, disabled = false }) => {
  return (
    <button
      onClick={onToggle}
      disabled={disabled}
      aria-label="Toggle favorite"
      className="p-1 transition-all disabled:opacity-50 group"
    >
      <Star
        className={`transition-all duration-200 ${
          isFavorite
            ? "text-yellow-400 group-hover:scale-110 group-hover:text-yellow-500"
            : "text-gray-400 group-hover:text-yellow-400"
        }`}
        fill={isFavorite ? "currentColor" : "none"}
        stroke="currentColor"
        width={20}
        height={20}
      />
    </button>
  );
};
export default StarFavorite;